import React, { ReactNode } from 'react';
import { ErrorBoundary as ReactErrorBoundary } from 'react-error-boundary';
import { reportReactError } from '@/shared/services/sentry';
import FallbackComponent from './fallback-component';

function ErrorBoundary({ children, title }: { children: ReactNode; title?: string }) {
  return (
    <ReactErrorBoundary
      FallbackComponent={({ error }) => {
        return <FallbackComponent error={error} title={title} />;
      }}
      onError={(error, info) => {
        console.error('ErrorBoundary caught an error:', error, info);
        reportReactError(error, info.componentStack ?? '');
      }}
    >
      {children}
    </ReactErrorBoundary>
  );
}

export default ErrorBoundary;
